<template>
  <div class="outBox">
    <div class="sortBtn">
      <el-button @click="handleSort">
        {{ sort === "down" ? "切到正序" : "切到降序" }}
        <i class="el-icon-sort"></i>
      </el-button>
    </div>
    <div class="box">
      <div
        v-loading="loading"
        element-loading-text="加载数据中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        class="mine"
      ></div>
      <div id="main" class="chart-container"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import titleImg from '@/assets/echarts/icon.png';
export default {
  name: "echartsOne",
  props: ["dataOne", "region"],
  data() {
    return {
      chart: null,
      loading: false,
      barData: this.dataOne,
      sort: "down",
      unit: {
        0: "元",
        1: "元",
        2: "港元",
        3: "澳元",
        4: "台币",
        5: "迪拉姆",
        6: "美元",
        7: "韩元",
      },
      titleImg,
    };
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("main"));
    this.initBar();
    const _this = this;
    this.$nextTick(function () {
      this.$on("resizeOne", function () {
        _this.chart.resize();
      });
    });
  },
  methods: {
    formatNumber(number) {
      if (number === null || number === undefined || isNaN(number)) return '0';

      const num = Number(number);
      
      // 拆分整数和小数
      const [integer, decimal] = num.toString().split('.');
      
      // 整数部分加千分位逗号
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      
      // 没有小数 → 直接返回
      if (!decimal) return formattedInteger;
      
      // 有小数 → 只保留最多2位，不补0
      const fixedDecimal = decimal.slice(0, 2);
      
      return `${formattedInteger}.${fixedDecimal}`;
    },
    handleSort() {
      this.sort = this.sort === "down" ? "up" : "down";
      this.barData = {
        yData: this.barData.yData.reverse(),
        xData: this.barData.xData.reverse(),
      };
      this.initBar();
    },
    initBar() {
      this.loading = true;
      const that = this;
      const containerWidth = this.chart.getWidth(); // 获取容器宽度
      const iconWidth = 22;
      const textWidth = 150; // 文字宽度 ≈ 字号 * 字数，可粗略估算或实时计算
      const totalWidth = iconWidth + 8 + textWidth; // 8 为间距
      const startX = (containerWidth - totalWidth) / 2;

      // 生成纯序号数组，只给y轴用
      const yIndexData = this.barData.yData.map((_, i) => i + 1);
      this.chart.setOption({
        // graphic: [
        //   {
        //     type: 'image',
        //     left: startX,
        //     top: 20,
        //     style: { image: that.titleImg, width: iconWidth, height: 24 },
        //   },
        //   {
        //     type: 'text',
        //     left: startX + iconWidth + 8,
        //     top: 24,
        //     style: { text: '景区销售排名', fill: '#fff', fontSize: 18, fontWeight: 'bold' },
        //   },
        // ],
        title: {
          text: '{img|} {text|景区销售排名}',
          top: 16,
          left: "76",
          textStyle: {
            fontSize: 18,
            fontWeight: "bold",
            color: "#fff",
            lineHeight: 22, // 和图标高度保持一致，强制单行对齐
            rich: {
              img: {
                backgroundColor: {
                  image: that.titleImg,
                },
                width: 22,
                height: 22,
                align: "center",
                padding: [0, 6, 0, 0]
              },
              text: {
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
                padding: [3, 0, 0, 0]
              },
            },
          },
        },
        tooltip: {},
        // 关键：扩大左侧边距，给序号和文字留出足够空间
        grid: {
          containLabel: false,
          left: 120, // 给序号留空间
          right: 50,
          top: 70,
          bottom: 90,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
            margin: 2,
            formatter: function (value, index) {
              if (value >= 10000) {
                value = value / 10000 + "万";
              }
              return value;
            },
          },
          axisTick: { show: false },
          axisLine: { show: false },
          splitLine: { show: false },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: yIndexData,
            categoryGap: 50,
            axisLabel: {
      show: true,
      color: '#fff',
      fontSize: 16,
      fontWeight: 'bold',
      padding: [0, 0, 22, 0],
      formatter: function(val) {
        if (val == 1) return `{a|${val}}`;
        if (val == 2) return `{b|${val}}`;
        if (val == 3) return `{c|${val}}`;
        return `{d|${val}}`;
      },
      rich: {
        a: { width: 30, height: 25, fontWeight: "bold", align: 'center', backgroundColor: '#FF6B35', color: '#000', borderRadius: 4, padding: [2, 0, 2, 0] },
        b: { width: 30, height: 25, fontWeight: "bold", align: 'center', backgroundColor: '#FFB74D', color: '#000', borderRadius: 4, padding: [2, 0, 2, 0] },
        c: { width: 30, height: 25, fontWeight: "bold", align: 'center', backgroundColor: '#4FC3F7', color: '#000', borderRadius: 4, padding: [2, 0, 2, 0] },    
        d: { width: 30, height: 25, fontWeight: "bold", align: 'center', backgroundColor: '#585858', color: '#fff', borderRadius: 4, padding: [2, 0, 2, 0] },
      }
    },
            axisTick: { show: false },
            axisLine: { show: false },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            zoomLock: true,
            show: true,
            start: 0,
            end:
              12 / this.barData.yData.length > 1
                ? 100
                : (12 / this.barData.yData.length) * 100,
            yAxisIndex: 0,
            orient: "vertical",
            right: 0,
            width: 20,
            brushSelect: false,
          },
        ],
        series: [
          {
            zlevel: -1, // 层级
            type: "bar",
            barWidth: 10,
            animationDuration: 1500,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(255, 255, 255, 0.2)",
              borderRadius: 10,
            },
            itemStyle: {
              barBorderRadius: 10,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                { offset: 0, color: "#3861fb" },
                { offset: 1, color: "#2fc0d2" },
              ]),
            },
            // 关键修改1：label 放在柱子左侧，左对齐，不与序号和柱子重叠
            label: {
              show: true,
              position: "left", // 把文字放到柱子左边
              offset: [10, -16], // 向右偏移10px，避免紧贴柱子
              color: "#fff",
              fontSize: 16,
              align: "left", // 文字左对齐
              formatter: function (params) {
                const name = that.barData.yData[params.dataIndex];
                const value = that.formatNumber(params.data);
                // 文字不带序号，直接显示景区名+金额
                return `${name}: {red|${value}${that.unit[that.region]}}`;
              },
              rich: {
                red: {
                  color: "#2bcbdf",
                  fontSize: 16,
                  fontWeight: "bold",
                },
              },
            },
            data: this.barData.xData,
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                let name = that.barData.yData[params.dataIndex];
                let value = params.value;
                return `<p>${name}</p><p>销售额：${that.formatNumber(value)}${
                  that.unit[that.region]
                }</p>`;
              },
            },
          },
        ],
      });
      this.loading = false;
    },
  },
  watch: {
    dataOne(newData) {
      this.barData = newData;
      this.initBar();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
};
</script>

<style scoped>
.outBox {
  width: 95%;
  margin: 0 auto;
  height: 800px;
}

.sortBtn {
  text-align: right;
  transform: translateY(46px);
  position: relative;
  z-index: 9;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}

.box {
  width: 100%;
  height: 800px;
  position: relative;
}

.mine {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%;
}
</style>